import React from 'react';

const SuspenseLoading = () => {
    return <div>loading...</div>
}

export default SuspenseLoading;